import { atom } from 'jotai';

import { SimpleLayoutProps } from './SimpleLayout.types';

export const sizeSimpleLayoutState = atom<SimpleLayoutProps['size']>(undefined);
